
import { supabase } from "@/integrations/supabase/client";

export const performEnhancedFallbackSearch = async (query: string) => {
  try {
    console.log('Performing enhanced fallback search...');
    
    // Try searching with partial matches and broader criteria
    const searchTerm = query.toLowerCase().trim();
    
    // Check if this is a specific search that we know we don't have
    const unavailableDestinations = [
      'afrika', 'safari door afrika', 'kenia', 'tanzania', 'botswana', 'zambia',
      'australië', 'nieuw-zeeland', 'japan', 'china', 'brazilië', 'argentinië'
    ];
    
    const isUnavailableDestination = unavailableDestinations.some(dest => 
      searchTerm.includes(dest)
    );
    
    if (isUnavailableDestination) {
      console.log('Query matches unavailable destination, returning empty results');
      return [];
    }

    const { data, error } = await supabase
      .from('TUI')
      .select('*')
      .not('imageURL', 'is', null)
      .not('name', 'is', null)
      .or(`region.ilike.%${searchTerm}%,city.ilike.%${searchTerm}%,country.ilike.%${searchTerm}%,name.ilike.%${searchTerm}%`)
      .limit(50);
    
    if (error) throw error;
    
    const validatedData = (data || []).map((vacation: any) => ({
      ...vacation,
      name: vacation.name || "Onbekende vakantie",
      imageURL: vacation.imageURL || "/placeholder.svg"
    }));
    
    return validatedData;
  } catch (error: any) {
    console.error('Enhanced fallback search error:', error);
    throw error;
  }
};

export const performBroadSearch = async (query: string) => {
  try {
    console.log('Performing broad search as last resort...');
    
    // Only do broad search for very generic terms
    const searchTerm = query.toLowerCase().trim();
    const isGenericSearch = 
      searchTerm === 'vakantie' || 
      searchTerm === 'reis' || 
      searchTerm === 'weekend' ||
      searchTerm.length <= 3;
    
    if (!isGenericSearch) {
      console.log('Not a generic search, avoiding broad results');
      return [];
    }
    
    // Very broad search - just look for any vacation with good images
    const { data, error } = await supabase
      .from('TUI')
      .select('*')
      .not('imageURL', 'is', null)
      .not('name', 'is', null)
      .limit(30);
    
    if (error) throw error;
    
    const validatedData = (data || []).map((vacation: any) => ({
      ...vacation,
      name: vacation.name || "Onbekende vakantie",
      imageURL: vacation.imageURL || "/placeholder.svg"
    }));
    
    return validatedData;
  } catch (error: any) {
    console.error('Broad search error:', error);
    throw error;
  }
};
